(() => {
	let filters           = document.querySelectorAll('[data-filter]');
	let dateLines         = document.querySelectorAll('[data-filter-dateline]');
	let showFiltersToggle = document.querySelector('[data-show-filters]');
	let hideFiltersToggle = document.querySelectorAll('[data-hide-filters]');
	let siblings;
	let haltEvent         = (event) => {
		event.stopPropagation();
		event.preventDefault();
	};
	
	let utmTail = '';

	if (document.location.search.indexOf('utm_')) {
		utmTail = document.location.search;
	}

	let getFilters        = () => {
		let activeFilters = {
			venues    : [],
			venueUrls : [],
			dates     : [],
			dateUrls  : [],
			others    : [],
			othersUrls: []
		};
		Array.prototype.forEach.call(filters, (filter) => {
			if (filter.checked) {
				switch (filter.getAttribute('data-filter-type')) {
					case 'date':
						activeFilters.dates.push(filter.getAttribute('data-filter-target'));
						activeFilters.dateUrls.push(filter.getAttribute('data-filter-url'));
						break;
					case 'venue':
						activeFilters.venues.push(filter.getAttribute('data-filter-target'));
						activeFilters.venueUrls.push(filter.getAttribute('data-filter-url'));
						break;
					case 'other':
						activeFilters.others.push(filter.getAttribute('data-filter-target'));
						activeFilters.othersUrls.push(filter.getAttribute('data-filter-url'));
						break;
				}
			}
		});
		return activeFilters;
	};
	let filterByClassName = (el, className, isVisible) => {
		return el.classList.contains(className) && (!isVisible || el.style.display !== 'none');
	};
	let getNextSiblings   = (el, filter, className, isVisible) => {
		siblings = [];
		while (el = el.nextElementSibling) {
			if (!filter || filter(el, className, isVisible)) {
				siblings.push(el);
			}
			else if (el.classList.contains('program__dateline')) {
				break;
			}
		}
		return siblings;
	};
	let checkDateLines    = () => {
		Array.prototype.forEach.call(dateLines, (line) => {
			let artistsByDate = getNextSiblings(line, filterByClassName, 'program__event', true);
			if (artistsByDate.length > 0) {
				line.classList.remove('filtered');	
			}
			else {
				line.classList.add('filtered');
			}
		});
	};
	let filterResults     = (e, activeFilters, noPushState) => {
		let container = document.querySelector('[data-filter-results]');
		if (container) {
			let activeFilters = activeFilters || getFilters();
			let pushState     = true;
			let url           = container.getAttribute('data-url');
			let objects       = container.querySelectorAll('[data-filter-target]');
			if (noPushState) {
				pushState = false;
			}
			Array.prototype.forEach.call(objects, (object) => {
				let venue = object.getAttribute('data-venue');
				let date  = object.getAttribute('data-date');
				let other = object.getAttribute('data-other').split('|');
				if ((activeFilters.venues.length === 0 || activeFilters.venues.indexOf(venue) >= 0) &&
						(activeFilters.dates.length === 0 || activeFilters.dates.indexOf(date) >= 0) &&
						(activeFilters.others.length === 0 || other.some(o => activeFilters.others.includes(o)))) {
					object.style.display = 'flex';
				}
				else {
					object.style.display = 'none';
				}
			});
			if (activeFilters.venues.length > 0) {
				let venues = '';
				Array.prototype.forEach.call(activeFilters.venueUrls, (venue) => {
					venues += venue + '+';
				});
				url += '/spillesteder/' + venues.substr(0, venues.length - 1);
			}
			if (activeFilters.dates.length > 0) {
				let dates = '';
				Array.prototype.forEach.call(activeFilters.dateUrls, (date) => {
					dates += date + '+';
				});
				url += '/datoer/' + dates.substr(0, dates.length - 1);
			}
			if (activeFilters.others.length > 0) {
				let others = '';
				Array.prototype.forEach.call(activeFilters.othersUrls, (other) => {
					others += other + '+';
				});
				url += '/annet/' + others.substr(0, others.length - 1);
			}
			if (utmTail) {
				url += utmTail;
			}
			if (window.location.hash) {
				url += window.location.hash;
			}
			if (pushState) {
				history.pushState({
					activeFilters: activeFilters,
					url          : url
				}, '', url);
			}
		}
		checkDateLines();
	};
	Array.prototype.forEach.call(filters, (filter) => {
		filter.addEventListener('change', filterResults);
	});
	window.addEventListener('popstate', () => {
		let activeFilters = history.state && history.state.hasOwnProperty('activeFilters') ? history.state.activeFilters : getFilters();
		let venueFilters  = document.querySelectorAll('[data-filter-type="venue"]');
		let dateFilters   = document.querySelectorAll('[data-filter-type="date"');
		let otherFilters  = document.querySelectorAll('[data-filter-type="other"');
		Array.prototype.forEach.call(venueFilters, (filter) => {
			if (history.state) {
				let target     = filter.getAttribute('data-filter-target');
				filter.checked = filter.checked && activeFilters.venues.indexOf(target) > -1;
			}
			else if (!window.location.hash) {
				filter.checked = false;
			}
		});
		Array.prototype.forEach.call(dateFilters, (filter) => {
			if (history.state) {
				let target     = filter.getAttribute('data-filter-target');
				filter.checked = filter.checked && activeFilters.dates.indexOf(target) > -1;
			}
			else if (!window.location.hash) {
				filter.checked = false;
			}
		});
		Array.prototype.forEach.call(otherFilters, (filter) => {
			if (history.state) {
				let target     = filter.getAttribute('data-filter-target');
				filter.checked = filter.checked && activeFilters.others.indexOf(target) > -1;
			}
			else if (!window.location.hash) {
				filter.checked = false;
			}
		});
		filterResults(null, activeFilters, true);
	});
	if (showFiltersToggle && hideFiltersToggle.length) {
		let showFilters = (e) => {
			haltEvent(e);
			document.body.classList.add('filters-active');
			document.getElementById('filters').classList.add('toggled');
			let artistElement = document.querySelector('.program__artists');
			if (artistElement) {
				artistElement.style.display = 'none';
			}
		};

		let hideFilters = (e) => {
			haltEvent(e);
			document.body.classList.remove('filters-active');
			document.getElementById('filters').classList.remove('toggled');
			let artistElement = document.querySelector('.program__artists');
			if (artistElement) {
				artistElement.style.display = '';
			}
			window.scrollTo(0, 0);
		};
		showFiltersToggle.addEventListener('click', showFilters);
		for (let i=0; i<hideFiltersToggle.length; i++) {
			hideFiltersToggle[i].addEventListener('click', hideFilters);
		}
		let getWindowWidth = () => {
			let w = window;
			let d = document;
			let e = d.documentElement;
			let b = d.getElementsByTagName('body')[0];
			return w.innerWidth || e.clientWidth || b.clientWidth;
		};
		let timer;
		window.addEventListener('resize', () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				let ww = getWindowWidth();
				if (ww >= 1280) {
					document.body.classList.remove('filters-active');
					document.getElementById('filters').classList.remove('toggled');
				}
			}, 10);
		});
	}
	filterResults();
})();